(ns frontend.ui.component.burger-menu.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]
   [frontend.ui.style.theme.core :refer [color]]
  ))

(defn menu
  []
  {:bmBurgerButton {:position    "relative"
                    :width       "36px"
                    :height      "30px"
                    :padding     10
                    :display     :flex
                    :align-items :center}
   :bmCrossButton  {:height 36
                    :width  36
                    :right  27
                    :top    15}
   :bmCross        {:background    (theme/color [:burger-menu :cross])
                    :width         2.7
                    :height        19
                    :border-radius 2}
   :bmMenuWrap     {:position "fixed"
                    :top      0
                    :width    300
                    :height   "100%"}
   :bmMenu         {:background     (theme/color [:burger-menu :menu :bg])
                    :padding        "60px 30px 32px"
                    :font-size      12
                    :font-weight    :bold
                    :letter-spacing 2.2}
   :bmMorphShape   {:fill "#373a47"}
   :bmItemList     {:color          (theme/color [:burger-menu :link :color])
                    :display        :flex
                    :flex-direction :column}
   :bmOverlay      {:top        0
                    :left       0
                    :background (theme/color [:burger-menu :overlay :bg])}})

(defn item
  []
  (with-meta
    {:display         "inline-block"
     :border-top      (space-join ["1px solid " (theme/color [:burger-menu :item :border])])
     :text-align      :center
     :text-decoration :none
     :padding         "33.6px 0"
     :outline         :none
     :text-transform  :uppercase
     :color           (theme/color [:burger-menu :item :link])}
    {:pseudo {:last-child {:border-bottom (space-join ["1px solid "
                                                       (theme/color [:burger-menu :item :border])])}
              :hover      {:color (theme/color [:burger-menu :link-hover :color])}}}))
